/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $PlayerCareerEntry = {
    properties: {
        position: {
            type: 'PlayerPositionEnum',
            isRequired: true,
        },
        dateFrom: {
            type: 'string',
            isRequired: true,
            format: 'date',
        },
        dateTo: {
            type: 'any-of',
            contains: [{
                type: 'string',
                format: 'date',
            }, {
                type: 'null',
            }],
            isRequired: true,
        },
        careerType: {
            type: 'CareerType',
            isRequired: true,
        },
        id: {
            type: 'number',
            isRequired: true,
        },
        teamName: {
            type: 'TranslationBase',
            isRequired: true,
        },
        leagueName: {
            type: 'TranslationBase',
            isRequired: true,
        },
        image: {
            type: 'Image',
            isRequired: true,
        },
        verified: {
            type: 'boolean',
            isRequired: true,
        },
        hidden: {
            type: 'boolean',
            isRequired: true,
        },
    },
} as const;
